// libs/core/src/lib/application-context/application-context.ts
var contextNotInitErrorMessage = "ApplicationContext not init";
var ApplicationContext = class {
  constructor(payload, isEmbedded = false) {
    this.payload = payload;
    this.isEmbedded = isEmbedded;
    this._activeSwapContext = null;
  }
  get connectWalletController() {
    if (!this._connectWalletController) throw new Error(contextNotInitErrorMessage);
    return this._connectWalletController;
  }
  get tokenController() {
    if (!this._tokenController) throw new Error(contextNotInitErrorMessage);
    return this._tokenController;
  }
  get notificationsController() {
    if (!this._notificationsController) throw new Error(contextNotInitErrorMessage);
    return this._notificationsController;
  }
  get i18nController() {
    if (!this._i18nController) throw new Error(contextNotInitErrorMessage);
    return this._i18nController;
  }
  get themesController() {
    if (!this._themesController) throw new Error(contextNotInitErrorMessage);
    return this._themesController;
  }
  get storageController() {
    if (!this._storageController) throw new Error(contextNotInitErrorMessage);
    return this._storageController;
  }
  get tokenRateProvider() {
    if (!this._tokenRateProvider) throw new Error(contextNotInitErrorMessage);
    return this._tokenRateProvider;
  }
  get oneInchDevPortalAdapter() {
    if (!this._oneInchDevPortalAdapter) throw new Error(contextNotInitErrorMessage);
    return this._oneInchDevPortalAdapter;
  }
  get sentryController() {
    if (!this._sentryController) throw new Error(contextNotInitErrorMessage);
    return this._sentryController;
  }
  async init() {
    const [
      connectWalletController,
      tokenController,
      notificationsController,
      i18nController,
      themesController,
      storageController,
      tokenRateProvider,
      oneInchDevPortalAdapter,
      sentryController
    ] = await Promise.all([
      this.payload.connectWalletControllerFactory(),
      this.payload.tokenControllerFactory(),
      this.payload.notificationsControllerFactory(),
      this.payload.i18nControllerFactory(),
      this.payload.themesControllerFactory(),
      this.payload.storageControllerFactory(),
      this.payload.tokenRateProviderFactory(),
      this.payload.oneInchDevPortalAdapterFactory(),
      this.payload.sentryControllerFactory()
    ]);
    this._connectWalletController = connectWalletController;
    this._tokenController = tokenController;
    this._notificationsController = notificationsController;
    this._i18nController = i18nController;
    this._themesController = themesController;
    this._storageController = storageController;
    this._tokenRateProvider = tokenRateProvider;
    this._oneInchDevPortalAdapter = oneInchDevPortalAdapter;
    this._sentryController = sentryController;
    await Promise.all([
      this._sentryController.init(this),
      this._i18nController.init(this),
      this._themesController.init(this),
      this._connectWalletController.init(this),
      this._notificationsController.init(this),
      this._tokenController.init(this),
      this._oneInchDevPortalAdapter.init(this)
    ]);
  }
  async makeSwapContext() {
    const context = await this.payload.swapContextFactory(this);
    this._activeSwapContext = new WeakRef(context);
    return context;
  }
  getActiveSwapContext() {
    return this._activeSwapContext?.deref() ?? null;
  }
};

// node_modules/.pnpm/@lit+context@1.1.3/node_modules/@lit/context/lib/create-context.js
function n(n2) {
  return n2;
}

// libs/core/src/lib/application-context/application-context-token.ts
var ApplicationContextToken = n(Symbol("ApplicationContextToken"));

// libs/core/src/lib/application-context/embedded-config-token.ts
var EmbeddedConfigToken = n(Symbol("EmbeddedConfigToken"));
export {
  ApplicationContext,
  ApplicationContextToken,
  EmbeddedConfigToken
};
//# sourceMappingURL=index.esm.js.map
